var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#fff",
    strokeWidth: 0.1875,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    color: "#fff",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "qrIconTitle"
  }, "QR Code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "qrIconTitle"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 7,
    height: 7,
    fill: "white",
    transform: "rotate(90 10 3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "white",
    transform: "matrix(-1 0 0 1 7 6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 7,
    height: 7,
    fill: "white",
    transform: "rotate(90 10 14)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1,
    height: 1,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 3,
    width: 7,
    height: 7,
    fill: "white",
    transform: "rotate(90 21 3)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.5200d4c6edcc171559ef2645fcb060e4.svg";
export { ForwardRef as ReactComponent };